import { useHistory, useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { UPDATE_CAMPAIGN_TYPE } from '../../../gql/campaign/mutation';

const CampaignScriptOption = () => {
    const { id } = useParams()
    const history = useHistory()
    const [updateCampaignType] = useMutation(UPDATE_CAMPAIGN_TYPE)


    return (
        <div className="container-fluid" style={{ backgroundColor: "#f5f7fb" }}>
            <div className="create-title">
                <h4>Choose Campaign type</h4>
            </div>
            <div className="campaign-success-box-container">
                <div className="campaign-success-image-container">
                </div>
                <div className="mx-5 mt-4" style={{ marginBottom: '48px' }} >
                    <h6 className="campaign-success-heading">
                        Would you like to?
                    </h6>
                </div>
                <div className="d-flex align-items-center justify-content-center mt-4 success_back_btn">
                <button type="button" className='solid-button' style={{ marginRight: '10px' }} onClick={ async () => {
                   const {data} =  await updateCampaignType({
                        variables: {
                            updateCampaignTypeInput: {
                                campaignId: id,
                                campaignType: "MANUAL_SCRIPT"
                            }
                        }
                    })
                    if(data){
                        history.push(`/campaigns/campaign-details/${id}`)} 
                    }
                    }>Write Manual Script</button>
                <button className='solid-button' type="button" id="autoGenerate" onClick={async () => {
                     const {data} =  await updateCampaignType({
                        variables: {
                            updateCampaignTypeInput: {
                                campaignId: id,
                                campaignType: "AUTO_SCRIPT"
                            }
                        }
                    })
                    if(data){
                        history.push(`/campaignAutoScript/${id}`)} 
                    }
                    }>Auto Generate Script</button>
                </div>

            </div>
        </div>
    );
};

export default CampaignScriptOption;
